import { ApplicationTypes, Model, attachComponent } from 'jms-domain'
import { Matrix4 } from 'three'

import {
  memoEval,
  propertyPageComponent,
  sceneEntityObjectTransformerComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { AdjustableDoorWallItemPropertyPage } from '../ui/property-pages/AdjustableDoorWallItemPropertyPage'
import { LynxProfessionalOutdoorBeverageDispenserPropertyPage } from '../ui/property-pages/LynxProfessionalOutdoorBeverageDispenserPropertyPage'

export const applianceComponents = [
  attachComponent
    .withComponent(propertyPageComponent, 'doorPage')
    .withAlias('BottomAdjustableDoorAppliance')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.NavigationState.RoomContent, ApplicationTypes.NavigationState.Recipes],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          page: <AdjustableDoorWallItemPropertyPage id={id} />,
        })
      )
    ),

  attachComponent
    .withComponent(propertyPageComponent, 'towerKitPage')
    .withEntity('LynxProfessionalOutdoorBeverageDispenserW24')
    .withFilter(s => ({
      navigationStates: [ApplicationTypes.NavigationState.RoomContent, ApplicationTypes.NavigationState.Recipes],
      selectedEntityIds: [s.id],
    }))
    .attach(
      memoEval(
        s => [s.id],
        id => ({
          page: <LynxProfessionalOutdoorBeverageDispenserPropertyPage id={id} />,
        })
      )
    ),

  attachComponent
    .withComponent(sceneEntityObjectTransformerComponent, 'flipBottomRefrigerationAppliance')
    .withAlias('BottomAdjustableDoorAppliance')
    .attach(
      memoEval(
        s => [s.handing],
        handing => ({
          target: 'default',
          transformer: mesh => {
            const matrix =
              handing === Model.Handing.left ? new Matrix4().makeScale(-1, 1, 1) : new Matrix4().makeScale(1, 1, 1)

            mesh.matrixAutoUpdate = false
            mesh.matrix.identity()
            mesh.applyMatrix4(matrix)
            mesh.updateMatrix()
          },
        })
      )
    ),
]
